<aumico-company-data-form
    [hideStatus]="hideStatus"
    [active]="active"
    [companyFormGroup]="companyFormGroup"
    [legalFormsOptions]="legalForms"
    [originalLegalForms]="originalLegalForms"
    [countryOptions]="countries"
    [industryOptions]="industries"
    [currentLanguage]="currentLanguage"
    [defaultLanguage]="defaultLanguage"
    [organizationUsers]="organizationUsers"
    [logo]="logo"
    [fileMetadata]="fileMetadata"
    [assignedUser]="assignedUser"
    [clerkUser]="clerkUser"
    [workflowOptions]="workflowOptions"
    [organizationHasCpmmActive]="organizationHasCpmmActive"
    [organizationHasMandateAndTaskManagementEnabled]="organizationHasMandateAndTaskManagementEnabled"
    [editMode]="editableMode"
    [isDeleting]="isDeleting"
    [activeCompany]="savedCompany"
    [canManageFx]="canManageFx"
    [fxBusy]="fxBusy"
    (countrySelectionChange)="onCountrySelectionChange($event)"
    (fileUploaded)="onLogoUploaded($event)"
    (tasksUpdateSelection)="onTasksUpdateSelection($event)"
    (fxActivate)="onFxActivate()"
    (fxDeactivate)="onFxDeactivate()"
    (fxPendingActivationChange)="onFxPendingActivationChange($event)"
    [tags]="tags"
    [tagUsage]="tagUsage"
    [tagError]="tagError"
    [linkedPersons]="linkedPersons"
    (tagCreate)="onTagCreate($event)"
    (tagDeleteRequest)="onTagDeleteRequest($event)"
    (tagDeleteConfirm)="onTagDeleteConfirm($event)"
    (tagDeleteCancel)="onTagDeleteCancel()"
    (linkedPersonClick)="onLinkedPersonClick($event)"
></aumico-company-data-form>
